// @flow
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import { formRightBtnBlock } from "../../../global/styles/generalStyles";
import ErrorDisplay, {
  setErrorMsg
} from "../../../global/components/ErrorDisplay";
import { StyledTextField, CancelButton, SubmitButton } from "imagus-components";
import DisplayFace from "./DisplayFace";
import ImageUploadProcess from "../facesearch/ImageUploadProcess";
import EnrolmentItem from "./EnrolmentItem";
import { EnrolmentType } from "../../../global/types/FaceType";
import {
  EnrolmentInputModel,
  initialPersonInput,
  PersonInputModel
} from "../../types/InputModels";
import { initialPerson, PersonType } from "../../types/UserType";
import { FaceSearchStateType } from "../../reducers/faceReducers";

const styles = (theme: DictionaryType): DictionaryType => ({
  formRightBtnBlock,
  clearBoth: {
    clear: "both"
  }
});

type CreatePersonFormStatesType = {
  errors: DictionaryType,
  loading: boolean,
  // name: string,
  // tags: Array<string>,
  // enrolments: Array<EnrolmentType>,
  // deleteEnrolments: Array<string>
  person: PersonInputModel
};

const inititalForm: CreatePersonFormStatesType = {
  errors: {},
  loading: false,
  person: initialPersonInput
  // name: "",
  // tags: [],
  // enrolments: [],
  // deleteEnrolments: []
};
type CreatePersonFormClassesType = {
  formRightBtnBlock: DictionaryType,
  clearBoth: DictionaryType
};

type CreatePersonFormPropsType = {
  classes: CreatePersonFormClassesType,
  onClose: Function,
  setMessage: Function,
  enrolments?: Array<EnrolmentType>,
  newEnrolments?: EnrolmentInputModel[],
  name?: string,
  tags?: Array<string>,
  fromDb?: boolean,
  isEdit?: boolean,
  uid?: string,
  faceSearch: FaceSearchStateType,
  tagList: string[],
  addNewPerson: Function,
  updatePerson: Function,
  dbAddPerson: Function,
  uploadFile: Function,
  ChipInput: React$ComponentType<*>
};

class CreatePersonForm extends Component<
  CreatePersonFormPropsType,
  CreatePersonFormStatesType
> {
  constructor(props: CreatePersonFormPropsType) {
    super(props);
    this.state = inititalForm;
  }

  componentDidMount() {
    let person: PersonInputModel = { ...this.state.person };

    if (this.props.enrolments) {
      person.currentEnrolments = [...this.props.enrolments];
    }

    if (this.props.newEnrolments) {
      person.newEnrolments = [...this.props.newEnrolments];
    }

    if (this.props.tags) {
      person.tags = [...this.props.tags];
    }
    if (this.props.name) {
      person.name = this.props.name;
    }

    if (this.props.uid) {
      person.uid = this.props.uid;
    }

    this.setState({ person: person });
  }

  componentWillUnmount() {
    this.setState(inititalForm);
  }

  handleChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      person: {
        ...this.state.person,
        [name]: value
      }
    });
  };

  syncChange = (name: string, value: *) => {
    this.setState({
      person: {
        ...this.state.person,
        [name]: value
      }
    });
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ loading: true });

    let person = this.state.person;

    if (this.props.fromDb) {
      //from DB
      if (this.props.isEdit) {
        //updating current person
        this.props.updatePerson(person, this.submitDone, this.submitFail);
      } else {
        //creating the person
        this.props.dbAddPerson(person, this.submitDone, this.submitFail);
      }
    }
  };

  submitDone = () => {
    this.setState({
      loading: false
    });
    this.props.setMessage(true, this.props.isEdit ? 0 : 1);
    this.props.onClose();
  };

  submitFail = (errors: DictionaryType) => {
    console.log("got to failed");
    this.setState({ loading: false, errors: errors });
  };

  setImageError = (error: string) => {
    this.setState({ errors: setErrorMsg(this.state.errors, "image", error) });
  };

  addEnrolement = (enrolment: EnrolmentInputModel) => {
    //remove error
    this.setState({ errors: {} });
    //add enrolment
    let newEnrolments = [...this.state.person.newEnrolments];
    newEnrolments.push(enrolment);
    this.setState({
      person: { ...this.state.person, newEnrolments: newEnrolments }
    });
  };

  deletePhoto = (enrolmentId: string) => {
    //remove error
    this.setState({ errors: {} });
    //delete photo
    let ce = this.state.person.currentEnrolments;
    let ci = ce.findIndex((e) => e.enrolmentId === enrolmentId);
    if (ci > -1) {
      //if in current enrolment
      //remove from current enrolment
      ce.splice(ci, 1);
      //add to delete list
      let de = [...this.state.person.deleteEnrolments];
      de.push(enrolmentId);
      //set new person state
      this.setState({
        person: {
          ...this.state.person,
          currentEnrolments: ce,
          deleteEnrolments: de
        }
      });
    } else {
      //in new enrolment
      let ne = [...this.state.person.newEnrolments];
      let ni = ne.findIndex((e) => e.enrolmentId === enrolmentId);
      //remove from new enrolment list if found
      if (ni > -1) {
        ne.splice(ni, 1);
      }
      this.setState({ person: { ...this.state.person, newEnrolments: ne } });
    }
  };

  uploadFile = (
    file: File | Blob,
    completeCall: Function,
    errorCall: Function
  ): * => {
    this.props.uploadFile(file, completeCall, errorCall, true);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const errors = this.state.errors;
    const loading = this.state.loading;

    let tagList = [];
    if (this.props.tagList) {
      tagList = this.props.tagList.sort().map((tag: string): * => ({
        value: tag,
        label: tag
      }));
    }
    const tags = this.state.person.tags.map((tag: string): * => ({
      label: tag,
      value: tag
    }));

    let enrolments: JSX.Element[] = [];

    if (this.state.person.currentEnrolments.length > 0) {
      //displaying all current enrolments
      enrolments.push(
        this.state.person.currentEnrolments.map((enrolment, i) => {
          return (
            <EnrolmentItem
              key={`thumb-${i}`}
              imgUrl={enrolment.faces[0].imgUrl}
              faces={enrolment.faces}
              {...(enrolment.faces.length > 1
                ? { badge: enrolment.faces.length }
                : {})}
              deletePhoto={() => this.deletePhoto(enrolment.enrolmentId)}
            />
          );
        })
      );
    }

    if (this.state.person.newEnrolments.length > 0) {
      //displaying new enrolments
      enrolments.push(
        this.state.person.newEnrolments.map((enrolment, i) => {
          return (
            <EnrolmentItem
              key={`new-thumb-${i}`}
              imgUrl={enrolment.imgUrl}
              deletePhoto={() => this.deletePhoto(enrolment.enrolmentId)}
            />
          );
        })
      );
    }

    const ChipInput = this.props.ChipInput;

    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="Name"
              name="name"
              value={this.state.person.name}
              onChange={this.handleChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <ChipInput
              name="tags"
              label="Tags"
              allowCreate
              isStyled
              isMultiple
              placeholder="Add a Tag"
              tags={tagList}
              value={tags}
              syncChange={this.syncChange}
            />
          </Grid>
          <Grid item xs={12}>
            {enrolments}
            <div className={classes.clearBoth} />
            <ImageUploadProcess
              detectedFaces={this.props.faceSearch.detectedFaces}
              uploadFile={this.uploadFile}
              buttonId="upload"
              setImageError={this.setImageError}
              addEnrolement={this.addEnrolement}
              personUid={this.props.uid}
              currentEnrolmentLength={
                this.state.person.currentEnrolments.length
              }
            />
          </Grid>
          <Grid item xs={12}>
            <ErrorDisplay errors={errors} />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.formRightBtnBlock}>
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton
                loading={loading}
                disabled={Object.keys(errors).length > 0}
              />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default withStyles(styles)(CreatePersonForm);
